module.exports = __webpack_public_path__ + "img/forms-active.c9fa12ea.svg";